import React, { useContext } from 'react';
import { useField, useForm } from 'react-final-form';

import Toggle from '@swf/components/Inputs/Toggle';
import Button from '@swf/components/StarsButton/StarsButton';

import CreateTournamentContext from '../../CreateTournamentContext/CreateTournamentContext';

import { TXTCLI_Edit, TXTCLI_Make_recurring } from './Toggle.messages.json';
import styles from './Toggle.scss';

const RecurrenceToggle: React.FC = () => {
  const form = useForm();
  const { setState } = useContext(CreateTournamentContext);
  useField('repeat', { defaultValue: false });

  const handleEditRecurrence = () => {
    form.change('repeat', true);
    setState((prevState) => ({ ...prevState, isRecurrenceOpen: true }));
  };

  return (
    <div className={styles.toggleContainer}>
      <Toggle id="repeat" label={TXTCLI_Make_recurring} type="checkbox" />
      <Button
        onClick={handleEditRecurrence}
        id="edit"
        type="submit"
        translation={TXTCLI_Edit}
        className={styles.submit}
        variant="text"
      />
    </div>
  );
};

export default RecurrenceToggle;
